import React from 'react';
import styled from 'styled-components';
import { Box, Flex } from '@latitude/box';
import { Link } from '@latitude/link';
import { Heading4 } from '@latitude/heading';
import { Text } from '@latitude/text';
import Icon from '@latitude/svg-inline/images/external-link.svg';
import { BREAKPOINT, COLOR, MARGIN, ALIGN } from '@latitude/core/utils/constants';
var defaultItems = [{
  title: 'Apple Pay',
  href: '/digital-wallets/apple-pay/',
  trackId: 'digital-wallets-apple-pay',
  imageSrc: require('./svg/logo-apple-pay-branded.svg')
}, {
  title: 'Google Pay',
  href: '/digital-wallets/google-pay/',
  trackId: 'digital-wallets-google-pay',
  imageSrc: require('./svg/logo-g-pay-branded.svg')
}, {
  title: 'Samsung Pay',
  href: '/digital-wallets/samsung-pay/',
  trackId: 'digital-wallets-samsung-pay',
  imageSrc: require('./svg/logo-samsung-pay-branded.svg'),
  width: 150
}, {
  title: 'Garmin Pay',
  href: '/digital-wallets/garmin-pay/',
  trackId: 'digital-wallets-garmin-pay',
  imageSrc: require('./svg/logo-garmin-pay-branded.svg')
}];

var DigitalWallets = function DigitalWallets(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? 'Ready, Set, Tap' : _ref$heading,
      subheading = _ref.subheading,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? defaultItems : _ref$data,
      noShadow = _ref.noShadow,
      variant = _ref.variant;
  return /*#__PURE__*/React.createElement(Container, {
    id: "digital-wallets"
  }, /*#__PURE__*/React.createElement(Box, {
    isResponsive: true,
    margin: "0 auto"
  }, /*#__PURE__*/React.createElement(Heading4, {
    color: COLOR.BLACK,
    align: ALIGN.CENTER
  }, heading), subheading && /*#__PURE__*/React.createElement(Subheading, null, subheading), /*#__PURE__*/React.createElement(LinkItems, {
    variant: variant
  }, data.map(function (item, i) {
    return /*#__PURE__*/React.createElement(LinkItem, {
      key: i,
      noStyle: true,
      noShadow: noShadow,
      href: item.href,
      trackId: "" + item.trackId,
      trackEventData: {
        label: item.title,
        location: heading
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: item.imageSrc.default,
      alt: item.title,
      width: item.width
    }), variant === 'partners' && /*#__PURE__*/React.createElement(StyledIcon, null));
  }))));
};

var Container = /*#__PURE__*/styled(Box).withConfig({
  displayName: "DigitalWallets__Container",
  componentId: "sc-1mi5gvq-0"
})(["position:relative;background-color:#f9f9f9;padding:40px 0;@media (min-width:", "){padding:72px 0;}"], BREAKPOINT.LG);
var Subheading = /*#__PURE__*/styled(Text).withConfig({
  displayName: "DigitalWallets__Subheading",
  componentId: "sc-1mi5gvq-1"
})(["max-width:600px;margin:0 auto ", ";text-align:center;"], MARGIN.M32);
var LinkItems = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "DigitalWallets__LinkItems",
  componentId: "sc-1mi5gvq-2"
})(["margin-top:-", ";flex-wrap:wrap;justify-content:center;"], MARGIN.M24);
var LinkItem = /*#__PURE__*/styled(Link).withConfig({
  displayName: "DigitalWallets__LinkItem",
  componentId: "sc-1mi5gvq-3"
})(["margin:", " calc(", " / 2) 0;display:flex;justify-content:center;align-items:center;width:100%;max-width:180px;height:48px;border-radius:4px;background:", ";box-shadow:0 1px 2px 0 rgba(0,0,0,0.25);&:hover{box-shadow:0 1px 3px 0 rgba(0,0,0,0.5);}", ""], MARGIN.M24, MARGIN.M24, COLOR.WHITE, function (props) {
  return props.noShadow && "box-shadow: none; background: none;\n      &:hover { box-shadow: none; }";
});
var StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  displayName: "DigitalWallets__StyledIcon",
  componentId: "sc-1mi5gvq-4"
})(["fill:", ";margin-left:", ";"], COLOR.BLUE_DEEP, MARGIN.M16);
export default DigitalWallets;